import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

import { myUseState } from "~/hooks/myUseState";
import { classNames } from "~/utils/utils";

import "./style.less";

interface IBlock {
	inlineStyleRanges: Array<{
		offset: number;
		length: number;
		style: string;
	}>;
	text: string;
}

export interface IWysiwygContent {
	getPlainText: () => string;
}

interface IWysiwyg {
	title?: string;
	error?: string;
	content?: IWysiwygContent;
	onChange?: (content: IWysiwygContent) => void;
}

export function contentToHTML(content: IWysiwygContent): string {
	const raw: {
		blocks: Array<IBlock>;
	} = convertToRaw(content);

	// zrusime styly - nechame bold atd. https://www.npmjs.com/package/draftjs-to-htmls
	raw.blocks.forEach(block => {
		block.inlineStyleRanges = block.inlineStyleRanges.filter(style => style.style.match(/[A-Z]+/u));
	});

	return draftToHtml(raw);
}

export function htmlToContent(html: string): IWysiwygContent {
	const blocksFromHTML = convertFromHTML(html);

	return ContentState.createFromBlockArray(
		blocksFromHTML.contentBlocks,
		blocksFromHTML.entityMap,
	);
}

export default function Wysiwyg({
	title = "Wysiwyg",
	error = "",
	content = null,
	onChange = () => {},
}: IWysiwyg) {
	const { state: stateEditor, setState: setStateEditor } = myUseState(content ? EditorState.createWithContent(content) : EditorState.createEmpty());

	function onEditorChange(newState: any) {
		const newContent: IWysiwygContent = newState.getCurrentContent();

		setStateEditor(newState);
		onChange(newContent);
	}

	return <div className={classNames(["wysiwyg", error ? "has-error" : ""])}>
		<div className="wysiwyg__comp">
			<h3 className="wysiwyg__title">
				{ title }
			</h3>
			<Editor editorState={stateEditor} onEditorStateChange={onEditorChange} wrapperClassName="wysiwyg__wrapper" editorClassName="wysiwyg__editor" />
		</div>
		<p className="wysiwyg__error">
			{ error }
		</p>
	</div>;
}
